@use 'src/globals/main';

pn-page-nav-item {
  position: relative;
  color: main.$white;
  margin-right: 0.5em;
  z-index: 2;
  white-space: nowrap;
  scroll-snap-align: center;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  transform: translateZ(0);

  a {
    text-decoration: none;
    color: main.$white;
    height: 100%;
    width: 100%;
    padding: 0.5em;
    font-weight: 500;
    border-radius: 3em;
    border: 0.0625em solid transparent;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    outline: none;
    transition: box-shadow 0.15s;

    &:focus {
      box-shadow: 0 0 0 0.1em main.$gray200;
    }

    & > pn-icon {
      margin-right: 0.5em;
    }
  }

  &:last-of-type {
    margin-right: 0;
  }
}
